import { ConcatAddressLine, CheckValidPostalCodeAndLine3And4Combination } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

function GetW9FieldPathValueMap(addressPath, wellFormedAddress) {
  const validPostalCodeAndLine3And4Combination = CheckValidPostalCodeAndLine3And4Combination(wellFormedAddress?.addressPostalCode, wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4);

  const fieldPathValueDictionary = [
    { key: `${ addressPath }.numberStreet`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityStateAndZipCode`, value: ConcatAddressLine([wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4, wellFormedAddress?.addressPostalCode], validPostalCodeAndLine3And4Combination) },
  ];

  return fieldPathValueDictionary;
}

function GetW9WellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: 'US'
  };

  const splitLine1 = formAddress?.numberStreet?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];
  const splitLine2 = formAddress?.cityStateAndZipCode?.split(',')?.map(x => x.trim())?.reverse() ?? ['', '', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  if (splitLine2.length >= 3) {
    [wellFormedAddress.postalCode, wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else if (splitLine2.length === 2) {
    [wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else {
    [...wellFormedAddress.line3] = splitLine2;
  }

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');
  wellFormedAddress.line3 = wellFormedAddress.line3.reverse().join(', ');

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  return GetW9FieldPathValueMap('address', wellFormedAddress);
}

export function GetWellFormedAddress(addressProps, addressValues) {
  return GetW9WellFormedAddress(addressValues?.address);
}
